module.exports = __webpack_public_path__ + "static/media/invoice-onboarding-free.06483818.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/invoice-onboarding-free.png
// module id = 648
// module chunks = 8